<template>
  <div class="container">
    <div class="container_main">
      <div class="container_top">
        <div class="container_bottom">
          <div class="container_center">
            <div class="center_header">
              <a class="logo" href="/">{{ $site.name }}</a>
              <div>
                <a href="/portal" class="btn_link">
                  <i class="iconfont link_icon iconzhumenhu"></i>主门户
                </a>
                <a href="/portal/college" class="btn_link">
                  <i class="iconfont link_icon iconicon_sketch"></i>特色产业学院
                </a>
                <a href="/admin/" class="btn_link" target="_blank">
                  <i class="iconfont link_icon iconintegral"></i>管理中心
                </a>
                <template v-if="isLogin">
                  <div class="dropdown" @mouseleave="hideMenu" @mouseenter="showMenu">
                    <span class="dropdown-trigger btn_link" @mouseenter="showMenu">
                      <svg-icon icon-class="user"></svg-icon>
                      {{ user.userName }}
                      <i class="el-icon-arrow-down"></i>
                    </span>
                    <ul class="dropdown-menu" @mouseleave="hideMenu" v-show="showDropMenu">
                      <li class="dropdown-menu__item" @click="handleCommand('profile')">
                        个人中心
                      </li>
                      <li class="dropdown-menu__item" @click="handleCommand('logout')">
                        退出登录
                      </li>
                    </ul>
                  </div>
                </template>
                <template v-else>
                  <a @click="login" class="btn_link">
                    用户登录
                  </a>
                  <a @click="login" class="btn_link">
                    免费注册
                  </a>
                </template>
              </div>
            </div>
            <div class="center_content" v-if="loaded">
              <div class="content_row">
                <system-item :item="systemList[0]"> </system-item>
                <system-item :item="systemList[1]"> </system-item>
              </div>
              <div class="content_row">
                <system-item :item="systemList[2]"> </system-item>
                <system-item :item="systemList[3]"> </system-item>
              </div>
              <div class="content_row">
                <system-item :item="systemList[4]"> </system-item>
                <system-item :item="systemList[5]"> </system-item>
              </div>
              <div class="content_row">
                <div class="content_row_column">
                  <system-item :item="systemList[6]"> </system-item>
                  <system-item :item="systemList[7]"> </system-item>
                </div>
                <system-item :item="systemList[8]"> </system-item>
              </div>
              <div class="content_row">
                <system-item :item="systemList[9]"> </system-item>
                <div class="content_row_column">
                  <system-item :item="systemList[10]"> </system-item>
                  <system-item :item="systemList[11]"> </system-item>
                </div>
              </div>
              <div class="content_row">
                <system-item :item="systemList[12]"> </system-item>
                <!-- <system-item :item="systemList[12]"> </system-item> -->
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div>
        我是Footer
      </div> -->
      <portal-footer></portal-footer>
    </div>
  </div>
</template>

<script>
import Mgr from "../../services/SecurityService"
import Footer from "@/views/portal/components/Footer"
import SystemItem from "./components/SystemItem"
import axios from "axios"
// const systemData = require("static/data/system.json");
export default {
  components: { [Footer.name]: Footer, SystemItem },
  data() {
    return {
      systemList: [],
      timer: null,
      user: { userName: "" },
      userMgr: new Mgr(),
      showDropMenu: false,
      isLogin: false,
      loaded: false
    }
  },
  mounted() {
    this.checkLogin()
    axios.get("static/data/system.json").then(res => {
      this.systemList = res.data
      console.log(this.systemList)
      this.loaded = true
    })
  },
  methods: {
    async checkLogin() {
      var that = this
      var isLogin = await this.userMgr.isLogin()
      this.isLogin = isLogin
      if (isLogin) {
        this.userMgr
          .getUser()
          .then(user => {
            that.user.userName = user.profile.NickName
          })
          .catch(err => {
            console.error("getUser", err)
          })
      }
    },
    hideMenu() {
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
      this.timer = setTimeout(() => {
        this.showDropMenu = false
      }, 150)
    },
    showMenu() {
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
      this.timer = setTimeout(() => {
        this.showDropMenu = true
      }, 150)
    },
    handleCommand(cmd) {
      console.warn(cmd)
      if (cmd === "logout") {
        this.userMgr.signOut()
      }
    },
    login() {
      this.userMgr.signIn()
    }
  }
}
</script>

<style lang="scss" scoped>
// div {
//   display: flex;
// }
.dropdown {
  font-size: 12px;
  color: $header-font-color;
  white-space: nowrap;
  display: inline-block;
  position: relative;
  z-index: 9;
  cursor: pointer;

  .dropdown-menu {
    position: absolute;
    top: 20px;
    right: 0;
    background-color: $header-font-color;
    color: $header-color;
    padding: 3px 20px;
    line-height: 22px;
    border-radius: 4px;
  }

  .dropdown-trigger {
    .svg-icon {
      vertical-align: middle;
      margin-top: -2px;
      margin-right: 1px;
      font-size: 16px;
    }
  }

  .dropdown-menu__item {
    cursor: pointer;
  }

  .dropdown-menu__item+.dropdown-menu__item {
    border-top: 1px solid #ddd;
    margin-top: 3px;
    padding-top: 3px;
  }
}

.container {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  position: relative;
}

.container_main {
  max-width: 1920px;
  width: 100%;
  height: 2330px;
  justify-content: center;
  align-items: center;

  .comp-portal-footer {
    position: relative;
    left: auto;
    bottom: auto;
  }
}

.module_box {
  height: 370px;
}

.container_top {
  width: 100%;
  height: 2330px;
  background-image: url(~assets/img/home/bg_top.png);
  background-repeat: no-repeat;
  background-position: center top;
}

.container_center {
  position: absolute;
  top: 0px;
  max-width: 1920px;
  width: 100%;
  height: 2330px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.container_bottom {
  position: relative;
  width: 100%;
  height: 2330px;
  background-image: url(~assets/img/home/bg_bottom.png);
  background-repeat: no-repeat;
  background-position: left bottom;
  display: flex;
  justify-content: center;
  flex: 1;
}

.center_header {
  display: flex;
  height: 80px;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  padding: 0px 40px;
  box-sizing: border-box;
  color: #ffffff;
  flex-shrink: 0;

  .logo {
    font-size: 0;
    line-height: 500px;
    overflow: hidden;
    background: url(~assets/img/logo.png) no-repeat;
    width: 346px;
    height: 40px;
  }

  .btn_link {
    color: #ffffff;
    font-size: 16px;
    margin-left: 40px;
    cursor: pointer;

    &:hover {
      color: #2be3bd;
    }

    &:last-child {
      margin-left: 0;

      &::before {
        content: ' ';
        height: 16px;
        width: 1px;
        display: inline-block;
        background: #ffffff;
        margin: 0px 16px -2px 16px;
        line-height: 28px;
      }
    }
  }

  .link_icon {
    margin-right: 5px;
  }
}

.center_content {
  display: flex;
  margin-top: 40px;
  flex-direction: column;
  width: 1174px;
  height: 100%;
}

.content_row {
  display: flex;
  justify-content: space-between;
}

.content_row_column {
  display: flex;
  flex-direction: column;
}
</style>
